function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");
var _ref3 = /*#__PURE__*/React.createElement("defs", null);
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "1.-Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tablet---Plattegrond",
  transform: "translate(-733.000000, -99.000000)",
  stroke: "#425cd4",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Refresh",
  transform: "translate(734.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.4383585,3.72088749 C17.7083057,1.68866989 15.1309156,0.398234911 12.2519407,0.398234911 C7.04322311,0.398234911 2.82103585,4.62042216 2.82103585,9.82855974 L2.82103585,12.60256",
  id: "Stroke-4"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-6",
  points: "5.50972238 8.96190941 2.82097786 12.602386 0.289985388 8.96190941"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.06540677,15.936522 C6.79545959,17.9693195 9.37284972,19.2591746 12.2518247,19.2591746 C17.4605422,19.2591746 21.6827295,15.0369873 21.6827295,9.82884972 L21.6827295,7.0548495",
  id: "Stroke-8"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-10",
  points: "19.1390356 10.7018217 21.6827875 7.05496549 24.3587726 10.7018217"
}))));
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "22px",
    viewBox: "0 0 27 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6BA5D4B4-844D-407A-AAFA-B392BC49203C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.337b52cfc09d3075b9d2291dd4678ca4.svg";
export { ForwardRef as ReactComponent };